<template>
  <div>
    <div class="mt-5">
      <v-card>
        <v-card-text>
          <div class="mt-5 text-center">
            <h1 class="grey--text">Bienvenido a DOSP S.A.</h1>
            <h5 class="mt-2 grey--text">Sistema de Control Interno</h5>
            <img src="@/assets/ticVerde.png" max-width="200" max-height="200"/>
          </div>
          <div class="mt-10 text-center">
            <h5 class="mt-2 grey--text">Fecha: {{hoy.toLocaleDateString()}}</h5>
            <h5 class="mt-2 grey--text">Usuario: {{usu}}</h5>
            <h5 class="mt-2 grey--text">Contrato: {{contrato}}</h5>
          </div>
        </v-card-text>
        <v-divider class="mt-5"></v-divider>
        <v-card-actions>
          <h6 class="mt-5 grey--text">Aplicacion Dops s.a.</h6>
          <v-spacer></v-spacer>
          <h6 class="mt-5 grey--text">Todos los derechos reservados, Copyright © StiTecnologia Solutions 2025</h6>
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>
<script>
export default {
    name: 'Bienvenido',
    props:['usu','contrato'],
    data(){
      return{ hoy:new Date()}
    }
}
</script>
